// extracted by mini-css-extract-plugin
export default {"wrap":"PolicyContainer_wrap__k3d8o","pageHeader":"PolicyContainer_pageHeader__QTK3K","pageGuide":"PolicyContainer_pageGuide__R+40F"};